<script setup lang="ts">
import {useForm} from "@inertiajs/vue3";
import {route} from "ziggy-js";
import VFieldLabel from "@/components/forms/VFieldLabel.vue";
import {Member} from "@/types";

interface Props {
    teamId: number
    user: Member
    items: Array<string>
}

const props = defineProps<Props>()
const value = defineModel<boolean>()

const form = useForm({
    internal_role: props.user.internal_role,
})

const submit = () => {
    form.put(route('teams.users.update', {team: props.teamId, user: props.user.id}), {
        preserveState: true,
        onSuccess: () => {
            value.value = false;
        },
    })
}

const closeDialog = () => {
    value.value = false;
    form.reset();
}
</script>

<template>
    <v-dialog
        v-model="value"
        max-width="500"
        scrim="blue-grey-darken-4"
        opacity="0.5"
        transition="dialog-top-transition"
    >
        <template #default>
            <v-card
                class="pa-1"
                rounded="lg"
            >
                <v-form @submit.prevent="submit">
                    <v-card-title class="font-weight-bold">
                        Edit member internal role
                        <v-btn
                            :icon="true"
                            color="base"
                            variant="plain"
                            rounded="lg"
                            class="float-end"
                            size="32"
                            @click="value = false"
                        >
                            <v-icon size="20">
                                mdi-close
                            </v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text class="text-body-2 px-4 py-0">
                        <p class="mb-5">
                            You're about to edit the internal role of "{{ props.user.name }}".
                        </p>
                        <v-alert
                            v-if="form.errors.internal_role"
                            variant="tonal"
                            type="error"
                            icon="mdi-alert-circle-outline"
                            icon-size="20"
                            class="text-body-2 mt-5 mb-2"
                        >
                            <span class="text-black">
                                {{ form.errors.internal_role }}
                            </span>
                        </v-alert>
                        <v-field-label>
                            Internal role
                        </v-field-label>
                        <v-combobox
                            v-model="form.internal_role"
                            :items="props.items"
                            density="compact"
                            autofocus
                            hide-details
                            hide-selected
                            variant="outlined"
                        />
                    </v-card-text>
                    <v-card-actions class="pt-0 mt-5">
                        <v-spacer />
                        <v-btn
                            color="white"
                            variant="flat"
                            border="sm"
                            type="button"
                            @click="closeDialog"
                        >
                            <span class="font-weight-regular">
                                Cancel
                            </span>
                        </v-btn>
                        <v-btn
                            variant="flat"
                            border="sm"
                            type="submit"
                        >
                            <span class="font-weight-regular">
                                Save changes
                            </span>
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </template>
    </v-dialog>
</template>

<style scoped>

</style>
